export const tokenExpiredMock = {
  sessionId: 'c35f743d-772b-4da7-adf5-4b33bb09664d',
};
